import Axios from 'axios';
import responseHandler from 'common/service/utils/responseHandler';
import errorHandler from 'common/service/utils/errorHandler';

export const DanqingAxiosInstance = Axios.create({ baseURL: '/danqingyue/api/v1' });
DanqingAxiosInstance.interceptors.response.use(responseHandler, errorHandler);
